import { render, staticRenderFns } from "./basicCardView.vue?vue&type=template&id=3a320ad8&scoped=true&"
import script from "./basicCardView.vue?vue&type=script&lang=js&"
export * from "./basicCardView.vue?vue&type=script&lang=js&"
import style0 from "./basicCardView.vue?vue&type=style&index=0&id=3a320ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a320ad8",
  null
  
)

export default component.exports